import DateRangeIcon from '@mui/icons-material/DateRange';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import MonetizationOnOutlined from '@mui/icons-material/MonetizationOnOutlined';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';

import {
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import React, { JSX } from 'react';
import {LicenseDetails} from '../../../../model/license/license-details.model';
import {OrganizationData} from '../../../../model/organization/organization-data';
import {FormatUtils} from '../../../../utils/format.utils';

type Props = {
  organizationData: OrganizationData
  licenseDetails: LicenseDetails,
  translate: (key: string) => string
  translateLocal: (key: string) => string
}

type HeaderItem = {
  icon: JSX.Element
  value: string
  title: string
}

export const OrganizationUsersHeader = ({licenseDetails, organizationData, translate, translateLocal}: Props) => {
  const headerItems: HeaderItem[] = [
    { icon: <PeopleOutlinedIcon />, value: organizationData.name, title: translateLocal('header.organization.title')},
    { icon: <DescriptionOutlinedIcon />, value: translate(`licenseType.${licenseDetails.licenseType}`), title: translateLocal('header.license-type.title')},
    { icon: <MonetizationOnOutlined />, value: FormatUtils.formatCurrency(licenseDetails.monthlyCost), title: translateLocal('header.base-cost.title')},
    { icon: <WhatshotIcon />, value: `${licenseDetails.discount.toFixed(2)}%`, title: translateLocal('header.discount.title')},
    { icon: <MonetizationOnOutlined />, value: FormatUtils.formatCurrency(licenseDetails.customerMonthlyCost), title: translateLocal('header.customer-cost.title')},
    { icon: <DateRangeIcon />, value: FormatUtils.formatDate(licenseDetails.licenseExpiredDate), title: translateLocal('header.expired-date.title')},
  ]

  const buildSimpleHeaderItem = (item: HeaderItem, index: number) => {
    return <Box key={index} display="flex" alignItems="center" gap={1}>
      {item.icon}
      <Typography variant="body2" fontWeight="bold">
        {item.title}:
      </Typography>
      <Typography variant="body2">{item.value}</Typography>
    </Box>
  }

  return (
    <Stack direction="row" spacing={4} alignItems="center">
      {headerItems.map((item, index) => buildSimpleHeaderItem(item, index))}
    </Stack>
  );
}